import template from './icon.html';

export const IconComponent = {
  name: 'uiIcon',
  restrict: 'E',
  template,
  controllerAs: 'vm',
  controller: ($scope, iconService) => {
    'ngInject';
    iconService.init($scope);
  },
  bindings: {
    name: '@'
  }
};
